// extracted by mini-css-extract-plugin
module.exports = {"title":"dialog_title__2uKE7","body":"dialog_body__1ssZu","footer":"dialog_footer__U4lMN"};